import styled from "styled-components";

export const Wrapper = styled.div`
  padding-top: 70px;
  text-align: center;
  font-size: 28px;
  font-weight: 300;
  color: ${props => props.theme.blueDark};

  @media print {
    padding-top: 50px;
  }

  &.second-unit-graph {
    padding-top: 45px;

    @media print {
      padding-top: 30px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/Header/style.js